import { InjectionToken } from '@angular/core';

export const ESCALATION_WAIT_TIME = new InjectionToken<number>('wait time');
